// // src/pages/avsync/Docs.js
// // AV Sync — Documentation Hub
// import React from "react";
// import "../../App.css";

// export default function Docs() {
//   return (
//     <div className="posts">
//       <h1>AV Sync — Documentation Hub</h1>
//       <p className="intro-text">
//         A centralized hub for all AV Sync documentation, setup instructions, and
//         handoff materials.
//       </p>

//       <div className="post-item">
//         <h2 className="post-title">Documentation Sections</h2>

//         <ul className="post-pargrphs">
//           <li>
//             <a className="post-links" href="/avsync/scanner">
//               Local Scanner Utility Documentation
//             </a>
//           </li>
//           <li>
//             <a className="post-links" href="/avsync/handoff">
//               Project Handoff & Maintenance Documentation
//             </a>
//           </li>
//           <li>
//             <a className="post-links" href="/avsync">
//               AV Sync Main Project Page
//             </a>
//           </li>
//         </ul>
//       </div>

//       <div className="post-item">
//         <h2 className="post-title">What’s Inside?</h2>
//         <ul className="post-pargrphs">
//           <li>Scanner Utility setup (Mac, Windows, UID instructions)</li>
//           <li>Architecture overview + API flow</li>
//           <li>How to build, maintain, and extend AV Sync</li>
//           <li>Handoff packet + instructions for future developers</li>
//         </ul>
//       </div>
//     </div>
//   );
// }
// src/pages/avsync/Docs.js
// AV Sync — Documentation Hub

import React from "react";
import "../../App.css";

export default function Docs() {
  return (
    <div className="posts">
      <h1>AV Sync — Documentation Hub</h1>
      <p className="intro-text">
        A centralized hub for all AV Sync documentation, setup instructions,
        developer notes, and handoff materials for future maintenance.
      </p>

      {/* --- CORE DOC LINKS --- */}
      <div className="post-item">
        <h2 className="post-title">Documentation Sections</h2>

        <ul className="post-pargrphs">
          <li>
            <a
              className="post-links"
              href="https://avsync.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              Launch Web App →
            </a>
          </li>
          <li>
            <a className="post-links" href="/avsync/scanner">
              Local Scanner Utility Documentation
            </a>
          </li>
          <li>
            <a className="post-links" href="/avsync/handoff">
              Handoff Packet & Developer Notes
            </a>
          </li>
          <li>
            <a className="post-links" href="/avsync">
              AV Sync Main Project Page
            </a>
          </li>
        </ul>
      </div>

      {/* --- INSIDE THE DOCUMENTATION --- */}
      <div className="post-item">
        <h2 className="post-title">What's Included</h2>

        <ul className="post-pargrphs">
          <li>
            Setup instructions for the Local Scanner Utility (Mac + Windows)
          </li>
          <li>Firebase UID linking guide for device syncing</li>
          {/* <li>API architecture overview + request flow</li> */}
          <li>Deployment notes (Web + Backend + Scanner)</li>
          <li>How to modify, maintain, or extend AV Sync</li>
          <li>Full handoff packet for future developers</li>
        </ul>
      </div>

      {/* --- OPTIONAL DOWNLOAD SECTION --- */}
      <div className="post-item">
        <h2 className="post-title">Quick Access</h2>
        <p className="post-pargrphs">
          Download the latest <strong>Local Scanner Utility (ZIP file)</strong>{" "}
          below. Works with Firebase UID syncing + the AV Sync backend API.
        </p>

        <a
          href="/assets/AVSync-LocalScanner-Release.zip"
          download
          className="download-btn"
        >
          Download Local Scanner Utility
        </a>

        <p className="post-pargrphs" style={{ marginTop: "1rem" }}>
          Need help? Visit the full Scanner Documentation page:
          <br />
          <a className="post-links" href="/avsync/scanner">
            Open Scanner Docs →
          </a>
        </p>
      </div>
    </div>
  );
}
